import { z } from "zod";
import { isCalendarDate } from "../../domain/order-confirmation";
import type { OrderConfirmationInput } from "../../domain/order-confirmation";
const text = z.string();
const number = z.number().finite();
const choice = z.enum(["ACCEPTED", "REJECTED", "CHANGE_REQUESTED"]);
const date = text.refine(isCalendarDate);
const plan = z.object({ date, quantity: number.positive(), note: text.optional() });
const response = z.object({
  id: text.min(1),
  responseType: choice,
  reason: text.nullable(),
  deliveryPlan: z.array(plan),
  createdAt: text.datetime({ offset: true })
});
const workspace = z.object({
  order: z.object({
    id: text.min(1),
    orderNo: text.min(1),
    supplierName: text,
    requestTitle: text,
    offerNo: text,
    quantity: number.positive(),
    unit: text,
    totalAmount: number.nonnegative(),
    currency: z.enum(["TRY", "USD", "EUR"]),
    paymentDays: number.int().nonnegative(),
    expectedDeliveryAt: date,
    deliveryAddress: text.nullable(),
    confirmationStatus: z.enum(["NOT_REQUESTED", "AWAITING", "ACCEPTED", "REJECTED", "CHANGE_REQUESTED"]),
    version: number.int().positive()
  }),
  responses: z.array(response),
});
export class OrderConfirmationError extends Error {
  constructor(message: string, readonly uncertain: boolean, readonly code = "") { super(message); }
}
export function parseOrderConfirmationWorkspace(value: unknown) {
  const parsed = workspace.safeParse(value);
  if (!parsed.success) throw new OrderConfirmationError("Sipariş bilgileri doğrulanamadı. Bilgileri yeniden yükleyin.", false);
  return parsed.data;
}
export function parseOrderConfirmationSession(value: unknown) {
  if (!z.object({ authenticated: z.literal(true), expiresAt: text.datetime({ offset: true }) }).safeParse(value).success)
    throw new OrderConfirmationError("Güvenli oturum sonucu doğrulanamadı. Bağlantıyı yeniden açın.", true);
}
export function parseOrderConfirmationResponse(value: unknown, input: OrderConfirmationInput) {
  const parsed = response.safeParse(value);
  if (!parsed.success || parsed.data.responseType !== input.responseType || parsed.data.reason !== (input.reason?.trim() || null) || JSON.stringify(parsed.data.deliveryPlan) !== JSON.stringify(input.deliveryPlan))
    throw new OrderConfirmationError("Yanıtın kaydedildiği doğrulanamadı. Aynı yanıtı tekrar gönderin.", true);
  return parsed.data;
}
export function orderConfirmationHttpError(value: unknown, status: number) {
  const parsed = z.object({ message: text.optional(), code: text.optional() }).safeParse(value);
  return new OrderConfirmationError(parsed.success && parsed.data.message ? parsed.data.message : "İşlem tamamlanamadı.", status >= 500, parsed.success ? parsed.data.code : undefined);
}
